/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, OnInit, signal} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './creative-retail-product-modal.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';
import {RetailProductListPageComponent} from '../retail-product/retail-product-list-page.component';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED, RetailProductListPageComponent],
  selector: 'adn-creative-retail-product-modal',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreativeRetailProductModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  selRetailProduct: any;
  onSelect: (product: any) => Promise<any> | any;

  createHook: (product: any) => void;
  private readonly disabledState = signal(false);
  get disabled(): boolean { return this.disabledState(); }
  set disabled(value: boolean) { this.disabledState.set(value); }

  constructor(public bsModalRef: BsModalRef) {
  }

  ngOnInit(): void {
    this.createHook = (product: any) => {
      if (!_.isFunction(this.onSelect) || this.disabled) {
        return;
      }
      this.disabled = true;
      Promise.resolve(this.onSelect(product)).then(() => {
        this.bsModalRef.hide();
      }).catch(() => undefined).finally(() => {
        this.disabled = false;
      });
    };
  }

  dismiss(): void {
    if (!this.disabled) {
      this.bsModalRef.hide();
    }
  }
}
